import { render, staticRenderFns } from "./VyungService.vue?vue&type=template&id=439356b9&"
import script from "./VyungService.vue?vue&type=script&lang=js&"
export * from "./VyungService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports